import apiClient from "@/services/apiClient.js";

export async function whoAmI() {
  const resp = await apiClient.get("/.auth/me");
  return resp.data.clientPrincipal;
}
